import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router';



import { Box, CircularProgress } from '@mui/material';



import { useCustomer } from '@features/Profile/hooks/use-customer.ts';



import withProtectedRoute from '@/app/routes/components/ProtectedRoute.tsx';





// Lazy load components with proper default imports
const LoginPage = lazy(() => import('@/features/Login/Login'));
const VerifyPage = lazy(() => import('@/features/EnterCode/EnterCode'));
const CustomerLandingPageContainer = lazy(() => 
  import('@/features/CustomerLandingPage/CustomerLandingPageContainer')
);
const NotFound = lazy(() => import('@/features/NotFound/NotFound'));

function LoadingFallback() {
  return (
    <Box 
      display="flex" 
      justifyContent="center" 
      alignItems="center" 
      height="100vh"
    >
      <CircularProgress />
    </Box>
  );
}

const ProtectedCustomerLandingPage = withProtectedRoute(CustomerLandingPageContainer)

export function AppRoutes() {
  const { data: customer } = useCustomer();
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        <Route path="/" element={customer ? <Navigate to="/landing" replace /> : <LoginPage />} />
        <Route
          path="/login"
          element={customer ? <Navigate to="/landing" replace /> : <LoginPage />}
        />
        <Route path="/verify" element={<VerifyPage />} />
        <Route path="/landing" element={<ProtectedCustomerLandingPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}
